import React from 'react';
import './FullPageLayout.css'; // CSS file for styling


const FullPageLayout = ({ children, className , targetRef, background}) => {
  const classes = ['full-page-layout'];

  if (className) {
    classes.push(className);
  }
  const style = {

  }
  if (background) {
    style["backgroundImage"] = `url(${background})`
  }
  return (
    <div ref={targetRef} className={classes.join(' ')} style={style}>
      {children}
    </div>
  );
};

export default FullPageLayout;